import { IApplicationState } from '../../types/redux';

export function getPlacesNearby(state: IApplicationState) {
  return state.newbuilding.placesNearby;
}
